import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.top}>
          <nav className={styles.links}>
            <Link to="/privacy">개인정보처리방침</Link>
            <span className={styles.divider} />
            <Link to="/terms">이용약관</Link>
            <span className={styles.divider} />
            <Link to="/support">고객지원</Link>
          </nav>
        </div>
        <div className={styles.bottom}>
          <p className={styles.copy}>© 2026 다잇. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
